
import { RootState } from '../../store';

export const selectCreateQualificationLoading = (state: RootState) => state.createQualification.loading;
export const selectCreateQualificationSuccess = (state: RootState) => state.createQualification.success;
export const selectCreateQualificationError = (state: RootState) => state.createQualification.error;
export const selectCreatedQualification = (state: RootState) => state.createQualification.qualification;

export const selectSearchQualificationsLoading = (state: RootState) => state.searchQualifications.loading;
export const selectSearchQualificationsSuccess = (state: RootState) => state.searchQualifications.success;
export const selectSearchQualificationsError = (state: RootState) => state.searchQualifications.error;
export const selectQualificationsList = (state: RootState) => state.searchQualifications.qualifications;
export const selectSearchQualificationsCount = (state: RootState) => state.searchQualifications.count;

export const selectUpdateQualificationLoading = (state: RootState) => state.updateQualification.loading;
export const selectUpdateQualificationSuccess = (state: RootState) => state.updateQualification.success;
export const selectUpdateQualificationError = (state: RootState) => state.updateQualification.error;

export const selectDeleteQualificationLoading = (state: RootState) => state.deleteQualification.loading;
export const selectDeleteQualificationSuccess = (state: RootState) => state.deleteQualification.success;
export const selectDeleteQualificationError = (state: RootState) => state.deleteQualification.error;

// Role Selectors

export const selectCreateRoleLoading = (state: RootState) => state.createRole.loading;
export const selectCreateRoleSuccess = (state: RootState) => state.createRole.success;
export const selectCreateRoleError = (state: RootState) => state.createRole.error;
export const selectCreatedRole = (state: RootState) => state.createRole.role;

export const selectSearchRolesLoading = (state: RootState) => state.searchRoles.loading;
export const selectSearchRolesSuccess = (state: RootState) => state.searchRoles.success;
export const selectSearchRolesError = (state: RootState) => state.searchRoles.error;
export const selectRolesList = (state: RootState) => state.searchRoles.roles;
export const selectSearchRolesCount = (state: RootState) => state.searchRoles.count;

export const selectUpdateRoleLoading = (state: RootState) => state.updateRole.loading;
export const selectUpdateRoleSuccess = (state: RootState) => state.updateRole.success;
export const selectUpdateRoleError = (state: RootState) => state.updateRole.error;

export const selectDeleteRoleLoading = (state: RootState) => state.deleteRole.loading;
export const selectDeleteRoleSuccess = (state: RootState) => state.deleteRole.success;
export const selectDeleteRoleError = (state: RootState) => state.deleteRole.error;

// Facility Type Selectors

export const selectCreateFacilityTypeLoading = (state: RootState) => state.createFacilityType.loading;
export const selectCreateFacilityTypeSuccess = (state: RootState) => state.createFacilityType.success;
export const selectCreateFacilityTypeError = (state: RootState) => state.createFacilityType.error;
export const selectCreatedFacilityType = (state: RootState) => state.createFacilityType.facilityType;

export const selectSearchFacilityTypesLoading = (state: RootState) => state.searchFacilityTypes.loading;
export const selectSearchFacilityTypesSuccess = (state: RootState) => state.searchFacilityTypes.success;
export const selectSearchFacilityTypesError = (state: RootState) => state.searchFacilityTypes.error;
export const selectFacilityTypesList = (state: RootState) => state.searchFacilityTypes.facilityTypes;
export const selectSearchFacilityTypesCount = (state: RootState) => state.searchFacilityTypes.count;

export const selectUpdateFacilityTypeLoading = (state: RootState) => state.updateFacilityType.loading;
export const selectUpdateFacilityTypeSuccess = (state: RootState) => state.updateFacilityType.success;
export const selectUpdateFacilityTypeError = (state: RootState) => state.updateFacilityType.error;

export const selectDeleteFacilityTypeLoading = (state: RootState) => state.deleteFacilityType.loading;
export const selectDeleteFacilityTypeSuccess = (state: RootState) => state.deleteFacilityType.success;
export const selectDeleteFacilityTypeError = (state: RootState) => state.deleteFacilityType.error;


// Document Type Selectors

export const selectCreateDocumentTypeLoading = (state: RootState) => state.createDocumentType.loading;
export const selectCreateDocumentTypeSuccess = (state: RootState) => state.createDocumentType.success;
export const selectCreateDocumentTypeError = (state: RootState) => state.createDocumentType.error;
export const selectCreatedDocumentType = (state: RootState) => state.createDocumentType.documentType;

export const selectSearchDocumentTypesLoading = (state: RootState) => state.searchDocumentTypes.loading;
export const selectSearchDocumentTypesSuccess = (state: RootState) => state.searchDocumentTypes.success;
export const selectSearchDocumentTypesError = (state: RootState) => state.searchDocumentTypes.error;
export const selectDocumentTypesList = (state: RootState) => state.searchDocumentTypes.documentTypes;
export const selectSearchDocumentTypesCount = (state: RootState) => state.searchDocumentTypes.count;

export const selectUpdateDocumentTypeLoading = (state: RootState) => state.updateDocumentType.loading;
export const selectUpdateDocumentTypeSuccess = (state: RootState) => state.updateDocumentType.success;
export const selectUpdateDocumentTypeError = (state: RootState) => state.updateDocumentType.error;

export const selectDeleteDocumentTypeLoading = (state: RootState) => state.deleteDocumentType.loading;
export const selectDeleteDocumentTypeSuccess = (state: RootState) => state.deleteDocumentType.success;
export const selectDeleteDocumentTypeError = (state: RootState) => state.deleteDocumentType.error;


// Designation Selectors

export const selectCreateDesignationLoading = (state: RootState) => state.createDesignation.loading;
export const selectCreateDesignationSuccess = (state: RootState) => state.createDesignation.success;
export const selectCreateDesignationError = (state: RootState) => state.createDesignation.error;
export const selectCreatedDesignation = (state: RootState) => state.createDesignation.designation;

export const selectSearchDesignationsLoading = (state: RootState) => state.searchDesignation.loading;
export const selectSearchDesignationsSuccess = (state: RootState) => state.searchDesignation.success;
export const selectSearchDesignationsError = (state: RootState) => state.searchDesignation.error;
export const selectDesignationsList = (state: RootState) => state.searchDesignation.designations;
export const selectSearchDesignationsCount = (state: RootState) => state.searchDesignation.count;

export const selectUpdateDesignationLoading = (state: RootState) => state.updateDesignation.loading;
export const selectUpdateDesignationSuccess = (state: RootState) => state.updateDesignation.success;
export const selectUpdateDesignationError = (state: RootState) => state.updateDesignation.error;

export const selectDeleteDesignationLoading = (state: RootState) => state.deleteDesignation.loading;
export const selectDeleteDesignationSuccess = (state: RootState) => state.deleteDesignation.success;
export const selectDeleteDesignationError = (state: RootState) => state.deleteDesignation.error;

// Role Document Mapping Selectors

export const selectCreateRoleDocumentMappingLoading = (state: RootState) => state.createRoleDocumentMapping.loading;
export const selectCreateRoleDocumentMappingSuccess = (state: RootState) => state.createRoleDocumentMapping.success;
export const selectCreateRoleDocumentMappingError = (state: RootState) => state.createRoleDocumentMapping.error;
export const selectCreateRoleDocumentMappingMessage = (state: RootState) => state.createRoleDocumentMapping.message;

export const selectRoleDocumentMappingLoading = (state: RootState) => state.getRoleDocumentMapping.loading;
export const selectRoleDocumentMappingSuccess = (state: RootState) => state.getRoleDocumentMapping.success;
export const selectRoleDocumentMappingError = (state: RootState) => state.getRoleDocumentMapping.error;
export const selectRoleDocumentMappingData = (state: RootState) => state.getRoleDocumentMapping.mapping;

// Facility Type Document Mapping Selectors

export const selectCreateFacilityTypeDocumentMappingLoading = (state: RootState) => state.createFacilityTypeDocumentMapping.loading;
export const selectCreateFacilityTypeDocumentMappingSuccess = (state: RootState) => state.createFacilityTypeDocumentMapping.success;
export const selectCreateFacilityTypeDocumentMappingError = (state: RootState) => state.createFacilityTypeDocumentMapping.error;
export const selectCreateFacilityTypeDocumentMappingMessage = (state: RootState) => state.createFacilityTypeDocumentMapping.message;

export const selectFacilityTypeDocumentMappingLoading = (state: RootState) => state.getFacilityTypeDocumentMapping.loading;
export const selectFacilityTypeDocumentMappingSuccess = (state: RootState) => state.getFacilityTypeDocumentMapping.success;
export const selectFacilityTypeDocumentMappingError = (state: RootState) => state.getFacilityTypeDocumentMapping.error;
export const selectFacilityTypeDocumentMappingData = (state: RootState) => state.getFacilityTypeDocumentMapping.mapping;

// Cancellation Reasons Selectors

export const selectCancellationReasonsLoading = (state: RootState) => state.searchCancellationReasons.loading;
export const selectCancellationReasonsSuccess = (state: RootState) => state.searchCancellationReasons.success;
export const selectCancellationReasonsError = (state: RootState) => state.searchCancellationReasons.error;
export const selectCancellationReasonsList = (state: RootState) => Array.isArray(state.searchCancellationReasons.reasons) ? state.searchCancellationReasons.reasons : [];
export const selectSearchCancellationReasonsCount = (state: RootState) => state.searchCancellationReasons.count;

export const selectCreateCancellationReasonLoading = (state: RootState) => state.createCancellationReason.loading;
export const selectCreateCancellationReasonSuccess = (state: RootState) => state.createCancellationReason.success;
export const selectCreateCancellationReasonError = (state: RootState) => state.createCancellationReason.error;
export const selectCreateCancellationReasonMessage = (state: RootState) => state.createCancellationReason.message;

export const selectUpdateCancellationReasonLoading = (state: RootState) => state.updateCancellationReason.loading;
export const selectUpdateCancellationReasonSuccess = (state: RootState) => state.updateCancellationReason.success;
export const selectUpdateCancellationReasonError = (state: RootState) => state.updateCancellationReason.error;
export const selectUpdateCancellationReasonMessage = (state: RootState) => state.updateCancellationReason.message;

export const selectDeleteCancellationReasonLoading = (state: RootState) => state.deleteCancellationReason.loading;
export const selectDeleteCancellationReasonSuccess = (state: RootState) => state.deleteCancellationReason.success;
export const selectDeleteCancellationReasonError = (state: RootState) => state.deleteCancellationReason.error;
export const selectDeleteCancellationReasonMessage = (state: RootState) => state.deleteCancellationReason.message;

// Bank Selectors

export const selectSearchBanksLoading = (state: RootState) => state.searchBanks.loading;
export const selectSearchBanksSuccess = (state: RootState) => state.searchBanks.success;
export const selectSearchBanksError = (state: RootState) => state.searchBanks.error;
export const selectBanksList = (state: RootState) => state.searchBanks.banks;
export const selectSearchBanksCount = (state: RootState) => state.searchBanks.count;

export const selectUploadBankCSVLoading = (state: RootState) => state.uploadBankCSV.loading;
export const selectUploadBankCSVSuccess = (state: RootState) => state.uploadBankCSV.success;
export const selectUploadBankCSVError = (state: RootState) => state.uploadBankCSV.error;
export const selectUploadBankCSVMessage = (state: RootState) => state.uploadBankCSV.message;

// Config Selectors

export const selectCreateConfigLoading = (state: RootState) => state.createConfig.loading;
export const selectCreateConfigSuccess = (state: RootState) => state.createConfig.success;
export const selectCreateConfigError = (state: RootState) => state.createConfig.error;
export const selectCreatedConfig = (state: RootState) => state.createConfig.config;

export const selectSearchConfigsLoading = (state: RootState) => state.searchConfigs.loading;
export const selectSearchConfigsSuccess = (state: RootState) => state.searchConfigs.success;
export const selectSearchConfigsError = (state: RootState) => state.searchConfigs.error;
export const selectConfigsList = (state: RootState) => state.searchConfigs.configs;
export const selectSearchConfigsCount = (state: RootState) => state.searchConfigs.count;

export const selectUpdateConfigLoading = (state: RootState) => state.updateConfig.loading;
export const selectUpdateConfigSuccess = (state: RootState) => state.updateConfig.success;
export const selectUpdateConfigError = (state: RootState) => state.updateConfig.error;

export const selectDeleteConfigLoading = (state: RootState) => state.deleteConfig.loading;
export const selectDeleteConfigSuccess = (state: RootState) => state.deleteConfig.success;
export const selectDeleteConfigError = (state: RootState) => state.deleteConfig.error;

export const selectListConfigsLoading = (state: RootState) => state.listConfigs.loading;
export const selectListConfigsSuccess = (state: RootState) => state.listConfigs.success;
export const selectListConfigsError = (state: RootState) => state.listConfigs.error;
export const selectListConfigsData = (state: RootState) => state.listConfigs.configs;

// Custom Form Selectors

export const selectCustomFormState = (state: RootState) => state.customForm;

export const selectCustomForms = (state: RootState) => state.customForm.forms;
export const selectCustomFormLoading = (state: RootState) => state.customForm.loading;
export const selectCustomFormError = (state: RootState) => state.customForm.error;
export const selectCustomFormSuccess = (state: RootState) => state.customForm.success;

// Map Inputs To Form Selectors

export const selectMapInputsToFormLoading = (state: RootState) => state.mapInputsToForm.loading;
export const selectMapInputsToFormSuccess = (state: RootState) => state.mapInputsToForm.success;
export const selectMapInputsToFormError = (state: RootState) => state.mapInputsToForm.error;
export const selectMapInputsToFormMessage = (state: RootState) => state.mapInputsToForm.message;

// Delete Custom Form Selectors

export const selectDeleteCustomFormLoading = (state: RootState) => state.deleteCustomForm.loading;
export const selectDeleteCustomFormSuccess = (state: RootState) => state.deleteCustomForm.success;
export const selectDeleteCustomFormError = (state: RootState) => state.deleteCustomForm.error;
export const selectDeleteCustomFormMessage = (state: RootState) => state.deleteCustomForm.message;

// Publish Custom Form Selectors

export const selectPublishCustomFormLoading = (state: RootState) => state.publishCustomForm.loading;
export const selectPublishCustomFormSuccess = (state: RootState) => state.publishCustomForm.success;
export const selectPublishCustomFormError = (state: RootState) => state.publishCustomForm.error;
export const selectPublishCustomFormMessage = (state: RootState) => state.publishCustomForm.message;

// Delete Custom Form Field Selectors

export const selectDeleteCustomFormFieldLoading = (state: RootState) => state.deleteCustomFormField.loading;
export const selectDeleteCustomFormFieldSuccess = (state: RootState) => state.deleteCustomFormField.success;
export const selectDeleteCustomFormFieldError = (state: RootState) => state.deleteCustomFormField.error;


// Get Custom Form Fields Selectors

export const selectGetCustomFormFieldsLoading = (state: RootState) => state.getCustomFormFields.loading;
export const selectGetCustomFormFieldsSuccess = (state: RootState) => state.getCustomFormFields.success;
export const selectGetCustomFormFieldsError = (state: RootState) => state.getCustomFormFields.error;
export const selectCustomFormFields = (state: RootState) => state.getCustomFormFields.fields;

export const selectAddCustomFormFieldLoading = (state: RootState) => state.addCustomFormField.loading;
export const selectAddCustomFormFieldSuccess = (state: RootState) => state.addCustomFormField.success;
export const selectAddCustomFormFieldError = (state: RootState) => state.addCustomFormField.error;

export const selectUpdateCustomFormFieldLoading = (state: RootState) => state.updateCustomFormField.loading;
export const selectUpdateCustomFormFieldSuccess = (state: RootState) => state.updateCustomFormField.success;
export const selectUpdateCustomFormFieldError = (state: RootState) => state.updateCustomFormField.error;

// Get Bank Form Fields Selectors

export const selectGetBankFormFieldsLoading = (state: RootState) => state.getBankFormFields.loading;
export const selectGetBankFormFieldsSuccess = (state: RootState) => state.getBankFormFields.success;
export const selectGetBankFormFieldsError = (state: RootState) => state.getBankFormFields.error;
export const selectBankFormFields = (state: RootState) => state.getBankFormFields.fields;

// Bank Form List Selectors

export const selectBankFormListLoading = (state: RootState) => state.bankFormList.loading;
export const selectBankFormListSuccess = (state: RootState) => state.bankFormList.success;
export const selectBankFormListError = (state: RootState) => state.bankFormList.error;
export const selectBankFormList = (state: RootState) => state.bankFormList.forms;

// Create Bank Form Field Selectors

export const selectCreateBankFormFieldLoading = (state: RootState) => state.createBankFormField.loading;
export const selectCreateBankFormFieldSuccess = (state: RootState) => state.createBankFormField.success;
export const selectCreateBankFormFieldError = (state: RootState) => state.createBankFormField.error;

// Update Bank Form Field Selectors

export const selectUpdateBankFormFieldLoading = (state: RootState) => state.updateBankFormField.loading;
export const selectUpdateBankFormFieldSuccess = (state: RootState) => state.updateBankFormField.success;
export const selectUpdateBankFormFieldError = (state: RootState) => state.updateBankFormField.error;

// Delete Bank Form Field Selectors

export const selectDeleteBankFormFieldLoading = (state: RootState) => state.deleteBankFormField.loading;
export const selectDeleteBankFormFieldSuccess = (state: RootState) => state.deleteBankFormField.success;
export const selectDeleteBankFormFieldError = (state: RootState) => state.deleteBankFormField.error;

// Soft Delete Bank Form Field Selectors

export const selectSoftDeleteBankFormFieldLoading = (state: RootState) => state.softDeleteBankFormField.loading;
export const selectSoftDeleteBankFormFieldSuccess = (state: RootState) => state.softDeleteBankFormField.success;
export const selectSoftDeleteBankFormFieldError = (state: RootState) => state.softDeleteBankFormField.error;

